import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  TOUCH,
} from "@nymbl/nos2-rules";
// src/components/team/PersonPanel.tsx
import { PersonEntriesTab } from "@/components/team/PersonEntriesTab";
import { PersonGuidanceTab } from "@/components/team/PersonGuidanceTab";
import { PersonSummaryTab } from "@/components/team/PersonSummaryTab";
import type { PanelTab, PanelTarget } from "@/components/team/panel-state";
import { formatMonth, type IsoDate } from "@/lib/time/dates";

const TABS: { value: PanelTab; label: string }[] = [
  { value: "summary", label: "Summary" },
  { value: "guidance", label: "Guidance" },
  { value: "entries", label: "Time entries" },
];

interface PersonPanelProps {
  target: PanelTarget | null;
  month: IsoDate;
  onChange: (target: PanelTarget | null) => void;
}

/** One side panel for every drill-down (DECISIONS 2026-10-15); full width on phones. */
export function PersonPanel({ target, month, onChange }: PersonPanelProps) {
  return (
    <Sheet open={target !== null} onOpenChange={(open) => !open && onChange(null)}>
      <SheetContent side="right" className="w-full overflow-y-auto sm:max-w-3xl lg:max-w-5xl">
        {target && (
          <>
            <SheetHeader>
              <SheetTitle className="font-display text-xl">{target.personName}</SheetTitle>
              <SheetDescription>{formatMonth(month)}</SheetDescription>
            </SheetHeader>
            <Tabs
              value={target.tab}
              onValueChange={(v) =>
                onChange({ ...target, tab: TABS.find((t) => t.value === v)?.value ?? "summary" })
              }
              className="gap-4 px-4 pb-6"
            >
              <TabsList aria-label="Person view">
                {TABS.map((t) => (
                  <TabsTrigger key={t.value} value={t.value} className={TOUCH}>
                    {t.label}
                  </TabsTrigger>
                ))}
              </TabsList>
              <TabsContent value="summary">
                <PersonSummaryTab personId={target.personId} month={month} />
              </TabsContent>
              <TabsContent value="guidance">
                <PersonGuidanceTab
                  personId={target.personId}
                  month={month}
                  active={target.tab === "guidance"}
                />
              </TabsContent>
              <TabsContent value="entries">
                <PersonEntriesTab
                  personId={target.personId}
                  month={month}
                  active={target.tab === "entries"}
                  filter={target.filter}
                />
              </TabsContent>
            </Tabs>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
}
